import { createSelector } from 'reselect';
import { getCurrentEvent } from '../event/event-selectors';

export const getCurrentOnsiteRequests = createSelector(
  getCurrentEvent,
  state => state.onsite.onsiteRequests,
  (event, onsiteRequests) =>
    event ? onsiteRequests.getIn([event.get('id'), 'data']) : null,
);
